// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as PlAltRanks from "./PlAltRanks.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ProfileIcon from "../components/ProfileIcon.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as PlGlobalStats from "./PlGlobalStats.bs.js";
import * as PlayerBookmark from "../player/PlayerBookmark.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import Tooltip from "@mui/material/Tooltip";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";
import Bookmark from "@mui/icons-material/Bookmark";

function PlBannerHor$ProfileIcon(Props) {
  var playerInfo = Props.playerInfo;
  var tier = Props.tier;
  var companionId = Props.companionId;
  CdnAtom.usePath(undefined);
  var basePath4 = CdnAtom.usePath4(undefined);
  var gmp;
  switch (tier) {
    case "challenger" :
    case "grandmaster" :
        gmp = true;
        break;
    default:
      gmp = false;
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "pointer-events-none rounded-full absolute " + (
                    gmp ? "left-[60px] top-[74px] w-[58px] h-[58px]" : "left-[59px] top-[69px] w-[62px] h-[62px]"
                  )
                }, React.createElement(ProfileIcon.make, {
                      id: playerInfo.profileIconId,
                      size: gmp ? 58 : 62
                    })), React.createElement("div", {
                  className: "pointer-events-none absolute " + (
                    gmp ? "left-[15px] top-[0px]" : "left-[10px] top-[-10px]"
                  )
                }, React.createElement("img", {
                      alt: tier,
                      src: basePath4 + "/banner/wings2_" + tier + ".png?w=" + (
                        gmp ? "150" : "160"
                      ),
                      width: gmp ? "150" : "160"
                    })), React.createElement("div", {
                  className: "absolute top-[105px] left-[100px] w-[40px] h-[40px]"
                }, React.createElement(LlIcon.make, {
                      companionId: companionId,
                      size: 40
                    })), React.createElement("div", {
                  className: "pointer-events-none absolute w-[70px] left-[84px] top-[95px]"
                }, React.createElement("img", {
                      alt: tier,
                      height: "70",
                      src: basePath4 + "/banner/" + tier + "_base3.png?w=70",
                      width: "70"
                    })));
}

var ProfileIcon$1 = {
  make: PlBannerHor$ProfileIcon
};

function PlBannerHor(Props) {
  var matches = Props.matches;
  var playerCompanionId = Props.playerCompanionId;
  var playerInfo = Props.playerInfo;
  var topRank = Props.topRank;
  var league = Props.league;
  var localRank = Props.localRank;
  var globalRank = Props.globalRank;
  var stats = Props.stats;
  var altRanks = Props.altRanks;
  var ranks = Props.ranks;
  var hidePctRanks = Props.hidePctRanks;
  CdnAtom.usePath(undefined);
  var basePath4 = CdnAtom.usePath4(undefined);
  var match = PlayerBookmark.use(undefined);
  var setFavorites = match[1];
  var favorited = Belt_Array.some(match[0], (function (f) {
          if (f.region === playerInfo.region) {
            return f.name === playerInfo.name;
          } else {
            return false;
          }
        }));
  var tier;
  if (league !== undefined) {
    var league$1 = league[1];
    switch (league$1) {
      case "BLUE" :
          tier = "diamond";
          break;
      case "GRAY" :
          tier = "silver";
          break;
      case "GREEN" :
          tier = "platinum";
          break;
      case "ORANGE" :
          tier = "grandmaster";
          break;
      case "PURPLE" :
          tier = "master";
          break;
      default:
        tier = Belt_Array.getExn(league$1.split(" "), 0).toLowerCase();
    }
  } else {
    tier = "iron";
  }
  var bgTier;
  if (league !== undefined) {
    var league$2 = league[1];
    switch (league$2) {
      case "BLUE" :
          bgTier = "diamond";
          break;
      case "GRAY" :
          bgTier = "silver";
          break;
      case "GREEN" :
          bgTier = "platinum";
          break;
      case "ORANGE" :
          bgTier = "grandmaster";
          break;
      case "PURPLE" :
          bgTier = "master";
          break;
      default:
        bgTier = Belt_Array.getExn(league$2.split(" "), 0).toLowerCase();
    }
  } else {
    bgTier = "default";
  }
  var unitFreqs = Belt_MutableMapString.make(undefined);
  Belt_Array.forEach(matches, (function (hp) {
          return Belt_Array.forEach(hp.info.units, (function (unit) {
                        var group = Belt_MutableMapString.getWithDefault(unitFreqs, unit.id, []);
                        group.push(unit.items.length);
                        return Belt_MutableMapString.set(unitFreqs, unit.id, group);
                      }));
        }));
  var match$1 = T.isNonLatinName(playerInfo.name);
  var match$2 = playerInfo.name.length;
  var tmp;
  if (localRank !== undefined && globalRank !== undefined && !hidePctRanks) {
    var localNum = localRank[0] + 1 | 0;
    var localPct = Caml.caml_float_max(localRank[1], 0.00001);
    tmp = React.createElement("div", {
          className: "leading-normal"
        }, React.createElement("div", undefined, Region.toName3(Region.fromApiName(playerInfo.region)) + " #" + localNum.toLocaleString()), React.createElement("div", undefined, "Top " + Global.formatPct(localPct < 0.001 ? 2 : 1, localPct) + "%"), React.createElement("div", {
              className: "pt-1"
            }, "Global #" + (globalRank[0] + 1 | 0).toLocaleString()), topRank !== undefined ? React.createElement("div", {
                className: "pt-1"
              }, "Peak rank: " + LpChartUtils.divisionToShortName(topRank[1]) + " " + String(topRank[2]) + "LP") : null);
  } else {
    tmp = null;
  }
  var tmp$1;
  if (localRank !== undefined && (!hidePctRanks || localRank[0] < 100)) {
    var localPct$1 = Caml.caml_float_max(localRank[1], 0.00001);
    var localNum$1 = localRank[0] + 1 | 0;
    tmp$1 = React.createElement("div", {
          className: "font-medium pt-[2px] text-[14px]"
        }, (
          localNum$1 < 1000 ? "#" + String(localNum$1) + " " : "Top " + Global.formatPct(localPct$1 < 0.001 ? 2 : 1, localPct$1) + "% "
        ) + Region.toName3(Region.fromApiName(playerInfo.region)));
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
              className: "flex flex-col items-center",
              id: "banner-hor"
            }, React.createElement("div", {
                  className: "flex w-full gap-4 justify-center sm:justify-center pt-2"
                }, React.createElement("div", {
                      className: "flex flex-col items-center"
                    }, React.createElement("div", {
                          className: "w-[180px] h-[320px] mb-[-14px] mx-[-10px]"
                        }, React.createElement("div", {
                              className: "mx-auto relative overflow-hidden"
                            }, React.createElement("div", {
                                  className: "ss-hidden cursor-pointer absolute top-[6px] left-[18px] z-[10] " + (
                                    favorited ? "text-legendary-3" : "text-white2"
                                  ),
                                  onClick: (function (param) {
                                      return Curry._1(setFavorites, (function (favorites) {
                                                    if (favorited) {
                                                      var cb = SnackbarService.sub.contents;
                                                      if (cb !== undefined) {
                                                        Curry._1(cb, playerInfo.name + " removed from bookmarks");
                                                      }
                                                      return Belt_Array.keep(favorites, (function (f) {
                                                                    return !(f.region === playerInfo.region && f.name === playerInfo.name);
                                                                  }));
                                                    }
                                                    var cb$1 = SnackbarService.sub.contents;
                                                    if (cb$1 !== undefined) {
                                                      Curry._1(cb$1, playerInfo.name + " added to bookmarks");
                                                    }
                                                    return Belt_Array.concat(favorites, [{
                                                                  region: playerInfo.region,
                                                                  name: playerInfo.name,
                                                                  puuid: playerInfo.puuid,
                                                                  tag: playerInfo.tag,
                                                                  littleLegend: playerCompanionId,
                                                                  tier: tier
                                                                }]);
                                                  }));
                                    })
                                }, React.createElement(Bookmark, {
                                      fontSize: "small",
                                      color: "inherit"
                                    })), React.createElement("div", {
                                  className: "mt-[-260px]"
                                }, React.createElement("img", {
                                      className: "pointer-events-none",
                                      height: "580",
                                      src: basePath4 + "/banner/bg2_" + bgTier + ".png?w=180",
                                      width: "180"
                                    })), React.createElement(PlBannerHor$ProfileIcon, {
                                  playerInfo: playerInfo,
                                  tier: tier,
                                  companionId: playerCompanionId
                                }), React.createElement("div", {
                                  className: "font-montserrat flex flex-col items-center absolute left-[15px] mx-auto top-[177px]"
                                }, React.createElement("div", {
                                      className: CssJs.merge([
                                            "notranslate font-semibold text-center max-w-[220px]",
                                            CssJs.style([
                                                  CssJs.lineHeight({
                                                        NAME: "abs",
                                                        VAL: 1.1
                                                      }),
                                                  CssJs.unsafe("wordBreak", "break-word")
                                                ]),
                                            match$1 ? (
                                                match$2 < 8 ? "text-xl" : (
                                                    match$2 < 11 ? "text-lg" : "text-base"
                                                  )
                                              ) : (
                                                match$2 < 10 ? "text-xl" : (
                                                    match$2 < 14 ? "text-lg" : "text-base"
                                                  )
                                              )
                                          ])
                                    }, playerInfo.name), React.createElement(Tooltip, {
                                      title: tmp,
                                      children: React.createElement("div", {
                                            className: "flex flex-col items-center leading-normal w-[150px]"
                                          }, React.createElement("div", {
                                                className: CssJs.merge([
                                                      "text-sm font-semibold whitespace-nowrap",
                                                      CssJs.style([CssJs.marginTop(CssJs.px(6))])
                                                    ])
                                              }, league !== undefined ? LpChartUtils.renderDivisionName(league[1]) + " " + (String(league[2]) + "LP") : "Unranked"), tmp$1)
                                    }))))), React.createElement(PlGlobalStats.make, {
                      stats: stats
                    })), altRanks !== undefined ? React.createElement("div", {
                    className: "mt-3 px-5 flex justify-end"
                  }, React.createElement(PlAltRanks.make, {
                        hrRank: Belt_Option.flatMap(ranks, (function (ranks) {
                                return ranks.hr;
                              })),
                        duoRank: Belt_Option.flatMap(ranks, (function (ranks) {
                                return ranks.duo;
                              }))
                      })) : null);
}

var make = PlBannerHor;

export {
  ProfileIcon$1 as ProfileIcon,
  make ,
  
}
/* T Not a pure module */
